// extracted by mini-css-extract-plugin
export default {"container":"EmptyState_container__9PVO8","title":"EmptyState_title__2minC","action":"EmptyState_action__UfRhm"};